import React from 'react';
import { Button } from 'antd';

const TeamPerformanceTitle = ({
  icon,
  title,
  showBtn = false,
  btnTitle,
  btnAction,
}: any) => (
  <div className="flex gap-2 items-center justify-between w-full">
    <div className="flex gap-2 items-center">
      {icon ? (
        <span
          className={`${title === 'Insights' ? 'bg-white' : 'bg-[#E8EBFA]'} text-[#120A8F] pt-3 pb-2 px-3 rounded`}
        >
          {icon}
        </span>
      ) : null}
      <h4 className={`${icon ? 'text-lg' : 'text-sm'} font-medium m-0`}>
        {title}
      </h4>
    </div>
    {showBtn ? (
      <Button onClick={btnAction} className="ml-auto" type="link">
        {btnTitle}
      </Button>
    ) : null}
  </div>
);

export default TeamPerformanceTitle;
